import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import './assets/scss/app.scss';
import 'bootstrap';
import 'react-toastify/dist/ReactToastify.css';

import ErrorBoundary from "./layouts/ErrorBoundary";
import AppLayout from "./layouts/AppLayout";
import {routes} from './navigation/routes';
import store, { history, persistor } from './store/store';

const App : React.FC = () => {

    useEffect(() => {

        //@ts-ignore
        document.fonts.load('1em beacons').then(function () {
            document.body.classList.remove('fonts-is-not-loaded');
        });

    }, []);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConnectedRouter history={history}>
                    <ErrorBoundary>
                        <AppLayout routes={routes} />
                        <ToastContainer />
                    </ErrorBoundary>
                </ConnectedRouter>
            </PersistGate>
        </Provider>
    );
}

export default App;
